import type { EngagementDockContentState } from "@/provider/EngagementProvider";
import type { ActiveDockTarget } from "@/orchestrators/useCaptainUpIntegration";

export type DockContentResolution = {
	nextDockContentState: EngagementDockContentState;
	nextActiveDockTarget: ActiveDockTarget;
	shouldSwitchTarget: boolean;
};

function hasContentForTarget(
	contentState: EngagementDockContentState,
	target: ActiveDockTarget
): boolean {
	if (target === "mission") {
		return contentState.missionHasContent;
	}

	return contentState.tournamentHasContent;
}

function resolveFallbackDockTarget(
	contentState: EngagementDockContentState,
	currentTarget: ActiveDockTarget
): ActiveDockTarget {
	if (currentTarget === "mission") {
		if (contentState.missionHasContent) {
			return "mission";
		}

		if (contentState.tournamentHasContent) {
			return "tournament";
		}

		return "mission";
	}

	if (contentState.tournamentHasContent) {
		return "tournament";
	}

	if (contentState.missionHasContent) {
		return "mission";
	}

	return "tournament";
}

export function resolveDockContentUpdate(
	currentTarget: ActiveDockTarget,
	nextContentState: EngagementDockContentState
): DockContentResolution {
	const currentTargetStillViable = hasContentForTarget(
		nextContentState,
		currentTarget
	);

	if (currentTargetStillViable) {
		return {
			nextDockContentState: nextContentState,
			nextActiveDockTarget: currentTarget,
			shouldSwitchTarget: false,
		};
	}

	const fallbackTarget = resolveFallbackDockTarget(
		nextContentState,
		currentTarget
	);

	return {
		nextDockContentState: nextContentState,
		nextActiveDockTarget: fallbackTarget,
		shouldSwitchTarget: fallbackTarget !== currentTarget,
	};
}